export const getNightOnlyMealVisibility = (nightOnly) => ({
  breakfast: !nightOnly,
  lunch: !nightOnly,
  dinner: true,
});


export const isNightOnlyDateEditable = (targetDate, berlinToday) => (
  Boolean(targetDate && berlinToday && targetDate >= berlinToday)
);
